import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-brown text-cream px-4 py-16 md:py-24" data-id="element-76">
      <div className="max-w-4xl mx-auto" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} data-id="element-78">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold mb-8 text-center" data-id="element-79">
            La Confrontación
          </h2>

          <div className="font-body text-lg md:text-xl leading-relaxed space-y-6" data-id="element-80">
            <p data-id="element-81">
              Entrás a la cocina, sentís el olor al pan recién horneado que
              trajo alguien de tu casa… y automáticamente te tensás.
            </p>

            <p data-id="element-82">
              Porque si sos celíaca, si tenés diabetes o si simplemente querés
              cuidarte, sabés cómo sigue la historia: terminás con "algo sin
              TACC" que parece telgopor, o con "algo sin azúcar" que igual te
              deja con ansiedad a la hora.
            </p>

            <p className="text-wheat font-semibold text-xl md:text-2xl" data-id="element-83">
              Mientras los demás disfrutan, vos te arreglás con lo que hay.
            </p>

            <p data-id="element-84">
              Y lo peor no es el sabor: es esa sensación de{' '}
              <span className="font-bold text-wheat" data-id="element-85">
                estar afuera del ritual
              </span>
              .
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}